import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'

import AnswersAvailability from 'modules/surveys/components/Form/AnswersAvailability'
import PrivacySetting from 'modules/surveys/components/Form/PrivacySetting'
import { useRespondents } from 'modules/surveys/hooks/useRespondents'
import { SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS } from 'modules/surveys/lib/constants'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type Survey from 'modules/surveys/store/models/v2/Survey'

import SurveyBasicInfo from 'modules/surveys/components/Configuration/SurveyBasicInfo'
import CycleConfiguration from './CycleConfiguration'
import EditorsSection from './Editors/EditorsSection'

const border = {
  width: 's1',
  style: 'solid',
  color: 'grey400',
} as const

function SurveySettings() {
  const { survey }: { survey: Survey | null | undefined } = useSurveyShowContext()
  const { loading: loadingRespondents, respondents } = useRespondents(survey)
  const canBeAnonymous = respondents.length >= SURVEY_MINIMUM_ANSWERS_TO_SHOW_ANONYMOUS
  if (loadingRespondents || !survey) return <Loading />

  return (
    <>
      <SurveyBasicInfo />
      {!survey.isWorkflowSurvey && (
        <Box
          border={{
            top: border,
          }}
        >
          <CycleConfiguration survey={survey} />
        </Box>
      )}

      <Box
        border={{
          top: border,
        }}
      >
        <PrivacySetting form={survey} canBeAnonymous={canBeAnonymous} />
      </Box>
      <Box
        border={{
          top: border,
        }}
      >
        <AnswersAvailability form={survey} />
      </Box>
      <Box
        border={{
          top: border,
        }}
      >
        <EditorsSection survey={survey} />
      </Box>
    </>
  )
}

export default observer(SurveySettings)
